import { makeBetterEnum } from './betterEnum';

export const FootprintStatus = makeBetterEnum(
  'Draft',
  'ReviewedByWatershed',
  'PendingWatershedReview',
  'Approved'
);

export type FootprintStatus =
  (typeof FootprintStatus)[keyof typeof FootprintStatus];

export const FootprintSnapshotStatus = makeBetterEnum('Publish', 'Draft');

export type FootprintSnapshotStatus =
  (typeof FootprintSnapshotStatus)[keyof typeof FootprintSnapshotStatus];

export const FootprintExportStatus = makeBetterEnum(
  'Processing',
  'Error',
  'Complete'
);
export type FootprintExportStatus =
  (typeof FootprintExportStatus)[keyof typeof FootprintExportStatus];

export const FootprintUsageType = makeBetterEnum(
  'FootprintExport',
  'Reductions',
  'SupplyChain',
  'Reporting'
);

export type FootprintUsageType =
  (typeof FootprintUsageType)[keyof typeof FootprintUsageType];

export const FootprintEmissionsKind = makeBetterEnum(
  'Ghg',
  'Waste',
  'SubstanceInflow',
  'SubstanceOutflow',
  'MicroplasticsInflow',
  'MicroplasticsOutflow',
  'WaterConsumption'
);
export type FootprintEmissionsKind =
  (typeof FootprintEmissionsKind)[keyof typeof FootprintEmissionsKind];

export const WatershedFootprintReviewRequestStatus = makeBetterEnum(
  'NeedsWatershedResponse',
  'WatershedReviewInitiated',
  'Done'
);
export type WatershedFootprintReviewRequestStatus =
  (typeof WatershedFootprintReviewRequestStatus)[keyof typeof WatershedFootprintReviewRequestStatus];

export const FootprintAssemblyRunStatus = makeBetterEnum(
  'Running',
  'Success',
  'Failed',
  'Canceled',
  'UserError'
);
export type FootprintAssemblyRunStatus =
  (typeof FootprintAssemblyRunStatus)[keyof typeof FootprintAssemblyRunStatus];
